export default class DateTime {
  public static get utcNow(): Date {
    return new Date(new Date().getTime());
  }
}
